import { defineStore } from "pinia";
import { getInstance } from "../api/api";
import { showErrorModal, showErrorNotifications, showToastSuccess, showToastWarning } from "../services/popups";
import { useIdxDBStore } from "./idxDB";

import time from "../services/time";
const api = getInstance();

export const useReportStore = defineStore('report', {
  state: () => ({
    reports:[], 
    report:{
        id: "",
        patientId: "",
        title: "",
        date: "",
        period: 0,
        humor: 0,
        description: ""
    },
    activeIconNavBar:false
  }),        
  actions: {             
    targetReportById(reportId) {
      let found  = this.reports.find(rep => rep.id === reportId);

      if (!found) { return; }

      this.report = found;
    },
    addReport(report) {
      report.title = report.title.toUpperCase();
      this.reports.unshift(report);
    },        
    updateReport(report) {
      if (this.reports.length == 0) {return;}

      let indexFound = this.reports.findIndex(x => x.id == report.id);
      
      if (indexFound == -1) {        
        return;
      }

      report.title = report.title.toUpperCase();

      this.reports[indexFound] = report;
    },
    removeReport(reportId) {
      if (this.reports.length == 0) {return;}

      let indexFound = this.reports.findIndex(x => x.id == reportId);
      
      if (indexFound == -1) {        
        return;
      }      
      this.reports.splice(indexFound, 1);
    },    
    clean() {      
      this.report = {
        id: "",
        patientId: "",
        title: "",
        date: "",
        period: 0,
        humor: 0,
        description: ""
      }    
    },
    preFillFields() {
      let now = time.methods.dateTimeNow();
      let hour = time.methods.getHour(now);
      if (hour < 12) {this.report.period = 1}
      else if (hour >= 12 && hour < 19) {this.report.period = 2}
      else if (hour >= 19) {this.report.period = 3}            
                            
      this.report.date = time.methods.shortDateToBackend(now);                                      
    },     
    async getReports(patientId) {
      let response;
      this.reports = [];
      try {
        response = await api.get("v1/Report/Summary", {params : {patientId}});        
        if (response.data.success && response.data.data) {
          response.data.data = response.data.data.sort((a, b) => (a.createdAt > b.createdAt) ? -1 : ((b.createdAt > a.createdAt) ? 1 : 0));
          this.reports = response.data.data;
        }        
      } catch (reason) {
        return;
      }      
    }, 
    async getReportById(reportId) {
      try {
        let response = await api.get("v1/Report", { params: { reportId } });                                    
        if (response.data.success) {    
          response.data.data.date = response.data.data.date.split('T')[0];               
          this.report = response.data.data;          
        }
      } catch {
        return;
      }                                   
    },
    async executeVisualize(patientId, report) {
      try {
        let response = await api.put("v1/Report/Visualize", {reportId:report.id} );                    
        if (!response.data.success) {          
          this.activeIconNavBar = true; 
          showErrorModal(response.data.message);
        }
        else {          
          this.activeIconNavBar = false;
          this.$router.push(`/patients/${patientId}/reports/`);
        }    
      } catch {
        return;
      }
    },
    async postUnsentReports() {
      if (!window.navigator.onLine) {return;}
      const idxDBStore = useIdxDBStore();
      let reports = [];
      idxDBStore.list("Relatos")
        .then(result => {          
          reports = result;
          reports.forEach(report => {                
            api.post("v1/Report", {...report})
              .then((response) => {
                if (response.data.success) {
                  idxDBStore.remove("Relatos", report.id);                            
                  let newReport = {...report};
                  newReport.id = response.data.data;
                  this.addReport(newReport);
                }
              })
              .catch(() => {
                console.log("Erro ao enviar Relato!");
              })                                                    
          });     
        })
        .catch((err) => {
          console.log(err);
        });                            
    },
    async postReport(report) {
      const idxDBStore = useIdxDBStore();
      idxDBStore.save("Relatos",{...report})
        .then(() => {
            if (window.navigator.onLine) {                                           
              api.post("v1/Report", {...report})
              .then(response => {
                if (!response.data.success) {
                  if (response.data.notifications)
                    showErrorNotifications(response.data.notifications);
                  else
                    showErrorModal(response.data.message);
                }
                else {
                  idxDBStore.remove("Relatos",report.id);
                  report.id = response.data.data;
                  this.addReport(report);
                  this.$router.push("/reports");
                  showToastSuccess("Relato enviado com sucesso!");
                }
              })                              
            }
            else {
              
              report.pending = true;
              this.addReport(report);              
              this.$router.push("/reports");

              setTimeout(() => {
                showToastWarning(                
                  "Não foi possível conectar-se a internet, seu relato ficará salvo e será enviado automaticamente assim que a conexão for estabelecida!"
                );
                                             
              }, 3100);                                                          
            }
        })
        .catch((error) => {
          console.log(error);
        })        
    },
    async putReport(report) {
      let response;
      try {                
        response = await api.put("v1/Report", {...report});
        if (!response.data.success) {
          if (response.data.notifications)
            showErrorNotifications(response.data.notifications);
          else
            showErrorModal(response.data.message);
        }
        else {
          this.$router.push("/reports");
        }
      } catch {
        return;
      }
    },
    async deleteReport(reportId) {
      let response;
      try {                
        response = await api.delete("v1/Report?", {params : {reportId}});
        if (!response.data.success) {          
          if (response.data.notifications)
            showErrorNotifications(response.data.notifications);
          else
            showErrorModal(response.data.message);
        }
        else {
          this.removeReport(reportId);      
          showToastSuccess("Relato deletado com sucesso!");
        }
      } catch {
        return;
      }
    }           
  }   
});      
    

